module.exports = __webpack_public_path__ + "static/media/yield.7ab1b419.jpg";